import gql from "graphql-tag";
import PostOrReplyAuthorFields from "./PostOrReplyAuthorFields";
import EditablePostFields from "./EditablePostFields";
import LockablePostFields from "./LockablePostFields";
import PinnablePostFields from "./PinnablePostFields";
import ReactableFields from "../ReactableFields";

export default gql`
  fragment PostFields on Post {
    _id
    shortId
    objectId
    bodyAsJson
    bodyAsPlainText
    createdAt

    author {
      ...PostOrReplyAuthorFields
    }

    ... on ForumPost {
      title
      lastRepliedAt

      ...LockablePostFields
      ...PinnablePostFields
      ...EditablePostFields
      ...ReactableFields
    }

    ... on CommonPost {
      ...EditablePostFields
      ...ReactableFields
    }

    viewerCanViewReplies
    viewerDidAuthor
    viewerCanEdit
    viewerCanDestroy
    viewerCanReply
  }

  ${LockablePostFields}
  ${PinnablePostFields}
  ${EditablePostFields}
  ${PostOrReplyAuthorFields}
  ${ReactableFields}
`;
